import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useConfirmTokenPurchaseMutation } from "../../redux/slices/paymentApiSlice";
import { CustomLoader } from "../../shared/components/others";
import { Box } from "@mui/material";

const TokenPurchaseSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [confirmPurchase, { isLoading: confirming }] = useConfirmTokenPurchaseMutation();

  useEffect(() => {
    const confirm = async () => {
      const sessionId = searchParams.get("session_id");

      if (!sessionId) {
        toast.error("Session ID invalide");
        navigate("/dashboard");
        return;
      }

      const res = await confirmPurchase({ session_id: sessionId });

      if (res?.data?.status === 200) {
        toast.success(res?.data?.message || "Achat confirmé !");
      } else {
        toast.error("Session ID invalide ou erreur de confirmation.");
      }

      navigate("/dashboard");
    };

    confirm();
  }, [searchParams, confirmPurchase, navigate]);

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        height={"50vh"}
      >
        <CustomLoader />
      </Box>
    </>
  );
};

export default TokenPurchaseSuccess;